const exportTypeEnum = {
  ORIGINAL: {
    code: 0,
    name: "ORIGINAL",
    desc: "原卷",
    kind: "exportType"
  },
  LEVEL: {
    code: 1,
    name: "LEVEL",
    desc: "等级",
    kind: "exportType"
  },
  SCORE: {
    code: 2,
    name: "SCORE",
    desc: "分数",
    kind: "exportType"
  },
}

export default Object.freeze(exportTypeEnum)